module.exports = __webpack_public_path__ + "img/fruit-pummelo-350x184.a674197e.jpg";